/**
 * Raised by the Apollo auth link when the token could not be refreshed, to stop
 * a request that is certain to fail. The user has already been shown the session
 * notification at that point, so `errorLink` recognises this error and does not
 * raise a second toast for it.
 */
export class SessionExpiredError extends Error {
  constructor() {
    super("Session expired");
    this.name = "SessionExpiredError";
  }
}

export function isSessionExpiredError(error: unknown): boolean {
  return error instanceof Error && error.name === "SessionExpiredError";
}
